<ng-container *transloco="let t">
  <div *ngIf="danceEvents?.length > 0; else noEvents" style="height: 100%;" [style]="{background: backgroundColorFromQueryParam}">
    <df-dance-event-lib-dance-event-preview-card
      *ngFor="let danceEvent of danceEvents"
      [danceEvent]="danceEvent"
      [clickable]="true"
      [hideDistance]="true"
      [isDmCard]="false"
      [clickOpensNewWindow]="true"
    ></df-dance-event-lib-dance-event-preview-card>
  </div>
  
  <ng-template #noEvents>
    <div style="height: 100%;" [style]="{background: backgroundColorFromQueryParam}" class="align-center pb2">
      <df-shared-empty-page
        [emptyTitle]="t('GENERIC_WRAPPER.NO_EVENTS')"
        [emptyDescription]="t('GENERIC_WRAPPER.NO_EVENTS_TEXT')"
        [imagePath]="'assets/images/events-manager/no_events.svg'"
        [hideBtn]="true"
      ></df-shared-empty-page>
    </div>
  </ng-template>
</ng-container>
